// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadTdgDocumentRequestModel from '../../model/download-tdg-document-request-model';
import DownloadTdgDocumentRequestDTO from '../dto/download-tdg-document-request-dto';
import dtoSchema from '../schemas/download-tdg-document-request-schema';

export default abstract class DownloadTdgDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadTdgDocumentRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<DownloadTdgDocumentRequestDTO>): DownloadTdgDocumentRequestModel;
  static toModel(dto: DeepPartial<DownloadTdgDocumentRequestDTO> | undefined | null): DownloadTdgDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadTdgDocumentRequestDTO> | undefined | null): DownloadTdgDocumentRequestModel | undefined {
    return dto ? new DownloadTdgDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadTdgDocumentRequestModel> | DownloadTdgDocumentRequestModel): DownloadTdgDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as DownloadTdgDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadTdgDocumentRequestModel, can not map to DownloadTdgDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
